import React, { useState } from "react";
import "../styles/ApplyForm.css";
import API_URL from "../apiConfig"; // Import the base API URL

export default function ApplyGNMForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    address: "",
    qualification: "",
    stream: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");
    let timeout;
    try {
      timeout = setTimeout(() => {
        setLoading(false);
        setErrorMsg("Request timed out. Please check your server.");
      }, 10000); // 10 seconds

      const response = await fetch(`${API_URL}/api/apply-gnm`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      clearTimeout(timeout);

      if (response.ok) {
        setSubmitted(true);
      } else {
        const data = await response.json().catch(() => ({}));
        setErrorMsg(data.error || "Failed to submit application");
      }
    } catch (error) {
      clearTimeout(timeout);
      setErrorMsg("Server error! Please check backend and network.");
      console.log("Fetch error:", error);
    }
    setLoading(false);
  };

  return (
    <div className="apply-form-main">
      <div className="apply-form-container">
        <h2>Apply for Nursing (GNM)</h2>
        {submitted ? (
          <div className="success-message">Your application has been submitted!</div>
        ) : (
          <form onSubmit={handleSubmit} className="apply-form">
            <label htmlFor="name">Full Name</label>
            <input type="text" id="name" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />

            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />

            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />

            <label htmlFor="dob">Date of Birth</label>
            <input type="date" id="dob" name="dob" placeholder="Date of Birth" value={formData.dob} onChange={handleChange} required />

            <label htmlFor="address">Address</label>
            <input type="text" id="address" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />

            <label htmlFor="qualification">Last Qualification</label>
            <input type="text" id="qualification" name="qualification" placeholder="Last Qualification" value={formData.qualification} onChange={handleChange} required />

            <label htmlFor="stream">Stream (Science/Arts/Commerce)</label>
            <input type="text" id="stream" name="stream" placeholder="Stream (Science/Arts/Commerce)" value={formData.stream} onChange={handleChange} required />

            <button type="submit" disabled={loading}>{loading ? "Submitting..." : "Submit Application"}</button>
            {errorMsg && <div className="error-message">{errorMsg}</div>}
          </form>
        )}
      </div>
    </div>
  );
}